import { prefStorage } from '@samknows/utils';
import viewTypes from '@/common/helpers/view-types';
import { isUserSessionSetup } from '@/common/services/account/userSession';

const UnitTestsView = (): Promise<unknown> =>
  import(
    /* webpackChunkName: "unit-tests-view"*/ '@/features/unit-tests-view/pages/UnitTestsView.vue'
  );
const UnitTests = (): Promise<unknown> =>
  import(
    /* webpackChunkName: "unit-tests-view"*/ '@/features/unit-tests-view/pages/UnitTests.vue'
  );
const RealSpeedTests = (): Promise<unknown> =>
  import(
    /* webpackChunkName: "unit-tests-view"*/ '@/features/unit-tests-view/pages/RealSpeedTests.vue'
  );

export default [
  {
    path: '/volunteers/dashboard',
    component: UnitTestsView,
    children: [
      {
        path: '',
        redirect: 'whitebox-tests'
      },
      {
        path: '/instant-test',
        name: 'instantTest',
        redirect: { name: 'CustomerDashboardWhiteboxTests' }
      },
      {
        path: 'whitebox-tests',
        name: 'CustomerDashboardWhiteboxTests',
        component: UnitTests,
        meta: {
          hasBackground: true,
          guard: () => isUserSessionSetup()
        }
      },
      {
        path: 'realspeed-tests',
        name: 'CustomerDashboardRealSpeedTests',
        component: RealSpeedTests,
        meta: {
          hasBackground: true,
          guard: () => {
            const activeView = viewTypes.activeView;

            return (
              isUserSessionSetup() &&
              prefStorage.get<boolean>(
                `instant-testable-${activeView.data.unitId}`,
                false
              )
            );
          }
        }
      }
    ]
  }
];
